import React, { useState, useEffect, createContext } from 'react';
import { useTheme, } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Typography, Box, Paper, Button } from '@mui/material';


import eLibraryDocument from '../../../types/legal/eLibraryDocument';
import agencyAction from '../../../types/legal/agencyAction';
import PressRelease from '../../../types/communication/pressRelease';

import LegalTable from './LegalTable';
import PressReleases from '../../Publications/components/PressReleases';

//take in array of years and text to display above them 
//map through array and return a button for each year
//each button should have an onClick that filters the advisoryOpinions array by year

interface Props {
  years: (number)[];
  eLibraryDocuments?: eLibraryDocument[];
  agencyActions?: agencyAction[];
  PressReleases?: PressRelease[];
  eLibraryDocumentType: string;
}

const ChronologicalButtonList = (props: Props): JSX.Element => {
  const [filteredELibDocuments, setFilteredELibDocuments] = useState<eLibraryDocument[]>([]);
  const [filteredAADocuments, setFilteredAADocuments] = useState<agencyAction[]>([]);
  const [filteredPressReleases, setPressReleases] = useState<PressRelease[]>([]);
  const [activeYear, setActiveYear] = useState<number | null>(null);

  const handleButtonClick = (year: number) => {
    setActiveYear(year);
    if (props.eLibraryDocuments) {
      const filtered = props.eLibraryDocuments.filter(opinion => opinion.year === year);
      setFilteredELibDocuments(filtered);
    } else if (props.agencyActions) {
      const filtered = props.agencyActions.filter(opinion => opinion.year === year);
      setFilteredAADocuments(filtered);
    } else if (props.PressReleases) {
      const filtered = props.PressReleases.filter(opinion => new Date(opinion.date).getFullYear() === year);
      setPressReleases(filtered);
    }
  };

  useEffect(() => {
    if (props.years && props.years.length > 0 && activeYear === null) {
      setActiveYear(props.years[0]);
    }
  }, [props.years]);

  useEffect(() => {
    if (activeYear === null) return;

    if (props.eLibraryDocuments) {
      const filtered = props.eLibraryDocuments.filter(
        (opinion) => opinion.year === activeYear
      );
      setFilteredELibDocuments(filtered);
    } else if (props.agencyActions) {
      const filtered = props.agencyActions.filter(
        (opinion) => opinion.year === activeYear
      );
      setFilteredAADocuments(filtered);
    } else if (props.PressReleases) {
      const filtered = props.PressReleases.filter(
        (opinion) => new Date(opinion.date).getFullYear() === activeYear
      );
      setPressReleases(filtered);
    }
  }, [activeYear, props.eLibraryDocuments, props.agencyActions, props.PressReleases]);


  return (
    <Box component={Paper} sx={{ p: 2, marginTop: 2 }}>
      <Box sx={{ paddingBottom: 2 }}>
        {props.eLibraryDocuments && <Typography variant="body1" align={'left'} paddingBottom={2}>
          Select a year to view a chronological listing of the {props.eLibraryDocumentType} issued, with summaries and links to the full text of each opinion.
        </Typography>}
        {props.PressReleases && <Typography variant="body1" align={'left'} paddingBottom={2}>
          View {props.eLibraryDocumentType} by year:
        </Typography>}
        {props.years.map(year => (
          <Button
            key={year}
            onClick={() => year !== undefined && handleButtonClick(year)}
            variant={(activeYear === year) ? 'contained' : 'text'}
            color={(activeYear === year) ? 'primary' : 'inherit'}
          >
            {year}
          </Button>
        ))}
      </Box>

      {props.eLibraryDocuments && (
        filteredELibDocuments.length > 0 ? (
          <LegalTable eLibraryDocuments={filteredELibDocuments} />
        ) : (
          <Typography variant="body1" align="center">No reports available for the selected year.</Typography>
        )
      )}

      {props.agencyActions && (
        filteredAADocuments.length > 0 ? (
          <LegalTable agencyActions={filteredAADocuments} />
        ) : (
          <Typography variant="body1" align="center">No reports available for the selected year.</Typography>
        )
      )}

      {props.PressReleases && (
        filteredPressReleases.length > 0 ? (
          <LegalTable PressReleases={filteredPressReleases} />
        ) : (
          <Typography variant="body1" align="center">No reports available for the selected year.</Typography>
        )
      )}
    </Box>
  );
};

export default ChronologicalButtonList;